import { useCallback } from "react"
import { services } from "@/services"
import type { Plan, PlanComparison, PlanModality } from "@/services/types"
import { useResource } from "@/shared/hooks/useResource"

/**
 * Planos e comparativo de uma modalidade.
 *
 * O `useCallback` com `[modality]` e o que amarra o recarregamento a troca de
 * aba: `useResource` refaz a leitura quando o loader muda de identidade. Uma
 * arrow inline no lugar dele recriaria a funcao a cada render e a leitura
 * entraria em laco.
 */
export function usePlans(modality: PlanModality) {
  const loadPlans = useCallback(() => services.plans.listPlans(modality), [modality])
  const loadComparison = useCallback(() => services.plans.getComparison(modality), [modality])

  const plans = useResource<Plan[]>(loadPlans)
  const comparison = useResource<PlanComparison>(loadComparison)

  return { plans, comparison }
}
